/**
 * Italian Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const it: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Cruscotto',
  'nav.funds': 'Fondi',
  'nav.investments': 'Investimenti',
  'nav.investees': 'Partecipate',
  'nav.esg': 'ESG Revisione',
  'nav.compliance': 'Conformità',
  'nav.reports': 'Report',
  'nav.settings': 'Impostazioni',
  'nav.users': 'Utenti',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Indicatori',
  'nav.taxonomy': 'Tassonomia UE',
  'nav.filings': 'Segnalazioni',
  'nav.calendar': 'Calendario',
  'nav.submit': 'Invia dati',
  'nav.submissions': 'Le mie sottomissioni',
  'nav.benchmarks': 'Benchmark',
  'nav.messages': 'Messaggi',
  'nav.portfolio': 'Portafoglio',
  'nav.performance': 'Performance dei fondi',
  'nav.esgSummary': 'ESG Riepilogo',
  'nav.pipeline': 'Pipeline',
  'nav.dueDiligence': 'Due Diligence',
  'nav.impact': 'Metriche di impatto',
  'nav.sdg': 'Mappatura OSS',
  'nav.audit': 'Traccia di audit',
  'nav.snapshots': 'Snapshot dei dati',
  'nav.knowledgeGraph': 'Grafo della conoscenza',
  'nav.geographic': 'Geografico',
  'nav.bi': 'BI Studio',
  'nav.ai': 'Assistente AI',
  'nav.tasks': 'Attività',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Monitor normativo',

  // Common Actions
  'action.create': 'Crea',
  'action.edit': 'Modifica',
  'action.delete': 'Elimina',
  'action.save': 'Salva',
  'action.cancel': 'Annulla',
  'action.submit': 'Invia',
  'action.approve': 'Approva',
  'action.reject': 'Rifiuta',
  'action.download': 'Scarica',
  'action.export': 'Esporta',
  'action.import': 'Importa',
  'action.filter': 'Filtra',
  'action.search': 'Cerca',
  'action.refresh': 'Aggiorna',
  'action.close': 'Chiudi',
  'action.back': 'Indietro',
  'action.next': 'Avanti',
  'action.previous': 'Precedente',
  'action.viewAll': 'Visualizza tutto',
  'action.viewDetails': 'Visualizza dettagli',
  'action.generate': 'Genera',
  'action.signOut': 'Esci',
  'action.addNew': 'Aggiungi nuovo',
  'action.invite': 'Invita',

  // Statuses
  'status.draft': 'Bozza',
  'status.submitted': 'Inviato',
  'status.validated': 'Validato',
  'status.approved': 'Approvato',
  'status.rejected': 'Rifiutato',
  'status.pending': 'In attesa',
  'status.inProgress': 'In corso',
  'status.overdue': 'In ritardo',
  'status.compliant': 'Conforme',
  'status.filed': 'Depositato',
  'status.active': 'Attivo',
  'status.inactive': 'Inattivo',
  'status.closed': 'Chiuso',
  'status.fundraising': 'Raccolta fondi',
  'status.investing': 'Investimento',
  'status.harvesting': 'Raccolta',
  'status.validating': 'In validazione',
  'status.review': 'In revisione',
  'status.monitoring': 'Monitoraggio',
  'status.exiting': 'Uscita',
  'status.pipeline': 'Pipeline',
  'status.due_diligence': 'Due Diligence',
  'status.disbursed': 'Erogato',
  'status.restructured': 'Ristrutturato',
  'status.matured': 'Scaduto',
  'status.written_off': 'Cancellato',
  'status.exited': 'Uscito',
  'status.incomplete': 'Incompleto',
  'status.open': 'Aperto',
  'status.in_progress': 'In corso',
  'status.completed': 'Completato',
  'status.cancelled': 'Annullato',
  'status.accepted': 'Accettato',
  'status.failed': 'Fallito',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Panoramica del portafoglio',
  'dashboard.complianceStatus': 'Stato di conformità',
  'dashboard.collectionProgress': 'Progresso della raccolta',
  'dashboard.activityFeed': 'Attività',
  'dashboard.quickActions': 'Azioni rapide',
  'dashboard.investmentPipeline': 'Pipeline di investimento',
  'dashboard.totalFunds': 'Totale fondi',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Investimenti attivi',
  'dashboard.totalInvestees': 'Partecipate',
  'dashboard.recentActivity': 'Attività recente',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Totale impegnato',
  'lp.capitalCalled': 'Capitale richiamato',
  'lp.distributed': 'Distribuito',
  'lp.netPosition': 'Posizione netta',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Performance dei fondi',
  'lp.esgSummary': 'ESG Riepilogo',
  'lp.reportLibrary': 'Libreria report',
  'lp.taxonomyAligned': 'Allineato alla tassonomia',
  'lp.paiCoverage': 'PAI Copertura',
  'lp.portfolioPerformance': 'Performance portafoglio LP',

  // Fund Labels
  'fund.name': 'Nome del fondo',
  'fund.code': 'Codice del fondo',
  'fund.vintage': 'Anno di costituzione',
  'fund.size': 'Dimensione del fondo',
  'fund.targetSize': 'Dimensione target',
  'fund.currency': 'Valuta',
  'fund.strategy': 'Strategia',
  'fund.status': 'Stato',
  'fund.sfdrCategory': 'SFDR Categoria',
  'fund.geographyFocus': 'Focus geografico',
  'fund.sectorFocus': 'Focus settoriale',

  // Form Labels
  'form.name': 'Nome',
  'form.email': 'E-mail',
  'form.country': 'Paese',
  'form.amount': 'Importo',
  'form.currency': 'Valuta',
  'form.date': 'Data',
  'form.description': 'Descrizione',
  'form.notes': 'Note',
  'form.type': 'Tipo',
  'form.period': 'Periodo',
  'form.year': 'Anno',
  'form.required': 'Obbligatorio',
  'form.optional': 'Facoltativo',

  // Table Headers
  'table.fund': 'Fondo',
  'table.commitment': 'Impegno',
  'table.called': 'Richiamato',
  'table.distributed': 'Distribuito',
  'table.tvpi': 'TVPI',
  'table.status': 'Stato',
  'table.regulation': 'Regolamento',
  'table.filingType': 'Tipo di segnalazione',
  'table.reportingPeriod': 'Periodo',
  'table.createdAt': 'Creato',
  'table.actions': 'Azioni',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'Tassonomia UE',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Completezza dei dati',
  'compliance.nextDeadline': 'Prossima scadenza',

  // Reports
  'report.quarterly': 'Report trimestrale',
  'report.annual': 'Report annuale',
  'report.paiStatement': 'PAI Dichiarazione',
  'report.taxonomyReport': 'Report tassonomia',
  'report.generatedAt': 'Generato',
  'report.version': 'Versione',

  // General
  'general.loading': 'Caricamento...',
  'general.noData': 'Nessun dato disponibile',
  'general.error': 'Si è verificato un errore',
  'general.retry': 'Riprova',
  'general.total': 'Totale',
  'general.page': 'Pagina',
  'general.of': 'di',
  'general.showing': 'Visualizzazione',
  'general.results': 'risultati',
  'general.language': 'Lingua',
  'general.english': 'Inglese',
  'general.french': 'Francese',

  // Tour
  'tour.takeTour': 'Fai il tour',
  'tour.skip': 'Salta',
  'tour.next': 'Avanti',
  'tour.prev': 'Indietro',
  'tour.finish': 'Fine',


  // Tour Content, Form Labels, Table Headers, Actions, Errors (i18n wiring)
  'tour.sidebarTitle': 'Navigazione',
  'tour.sidebarContent': 'Usa la barra laterale per navigare tra gestione del portafoglio, raccolta dati ESG, conformità, report e strumenti di intelligence.',
  'tour.kpisTitle': 'Panoramica del portafoglio',
  'tour.kpisContent': 'Queste schede mostrano il tuo portafoglio a colpo d\'occhio — fondi totali, AUM, investimenti attivi e numero di partecipate.',
  'tour.actionsTitle': 'Azioni rapide',
  'tour.actionsContent': 'Crea fondi, aggiungi investimenti, invita partecipate e genera report con un clic.',
  'tour.languageTitle': 'Lingua',
  'tour.languageContent': 'Passa tra 24 lingue ufficiali dell\'UE. L\'intera interfaccia si traduce istantaneamente.',
  'tour.aiTitle': 'Assistente AI',
  'tour.aiContent': 'Fai domande sul tuo portafoglio in qualsiasi momento. L\'assistente AI ha il contesto completo sui tuoi fondi e investimenti.',
  'action.createFund': 'Crea fondo',
  'action.editFund': 'Modifica fondo',
  'action.addInvestment': 'Aggiungi investimento',
  'action.addInvestee': 'Aggiungi partecipata',
  'action.editInvestee': 'Modifica partecipata',
  'action.createTemplate': 'Crea modello',
  'action.createSubmission': 'Crea sottomissione',
  'action.createFiling': 'Crea segnalazione',
  'action.generateReport': 'Genera report',
  'action.inviteUser': 'Invita utente',
  'action.sendInvitation': 'Invia invito',
  'action.saveChanges': 'Salva modifiche',
  'form.fundName': 'Nome del fondo',
  'form.fundCode': 'Codice del fondo',
  'form.sfdrCategory': 'Categoria SFDR',
  'form.baseCurrency': 'Valuta di base',
  'form.targetSize': 'Dimensione target',
  'form.vintageYear': 'Anno di costituzione',
  'form.geographyFocus': 'Focus geografico',
  'form.sectorFocus': 'Focus settoriale',
  'form.investmentCode': 'Codice investimento',
  'form.instrumentType': 'Tipo di strumento',
  'form.maturityDate': 'Data di scadenza',
  'form.sector': 'Settore',
  'form.countryCode': 'Codice paese',
  'form.entityType': 'Tipo di entità',
  'form.region': 'Regione',
  'form.staffCount': 'Numero dipendenti',
  'form.borrowers': 'Mutuatari',
  'form.contactName': 'Nome contatto',
  'form.contactEmail': 'E-mail contatto',
  'form.templateName': 'Nome del modello',
  'form.templateType': 'Tipo di modello',
  'form.indicators': 'Indicatori',
  'form.reportingPeriod': 'Periodo di reporting',
  'form.reportingYear': 'Anno di reporting',
  'form.regulation': 'Regolamento',
  'form.filingType': 'Tipo di segnalazione',
  'form.reportType': 'Tipo di report',
  'form.emailAddress': 'Indirizzo e-mail',
  'form.role': 'Ruolo',
  'form.selectFund': 'Seleziona fondo...',
  'form.selectInvestee': 'Seleziona partecipata...',
  'table.code': 'Codice',
  'table.investee': 'Partecipata',
  'table.instrument': 'Strumento',
  'table.amount': 'Importo',
  'table.currency': 'Valuta',
  'table.maturity': 'Scadenza',
  'table.name': 'Nome',
  'table.country': 'Paese',
  'table.type': 'Tipo',
  'table.period': 'Periodo',
  'table.completion': 'Completamento',
  'table.submitted': 'Inviato',
  'table.version': 'Versione',
  'table.indicators': 'Indicatori',
  'table.dueDate': 'Data di scadenza',
  'table.generated': 'Generato',
  'table.email': 'E-mail',
  'table.role': 'Ruolo',
  'error.createFailed': 'Creazione fallita. Riprova.',
  'error.updateFailed': 'Aggiornamento fallito. Riprova.',
  'error.loadFailed': 'Caricamento dati fallito.',
};
